import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, map } from 'rxjs';

import { flightsRootRoute } from '@flights/flights-routing.module';
import { flightResultsRootRoute } from '@flight-results/flight-results-routing.constants';
import { hotelsHomeRootRoute } from '@hotels/hotels-home/hotels-home-routing.module';
import { hotelResultsRootRoute } from '@hotels/hotel-results/hotel-results-routing.module';
import { hotelDetailRootRoute } from '@hotels/hotel-detail/hotel-detail-routing.module';
import { busesRootRoute } from '@buses/bus-home/bus-home-routing.module';
import { busResultsRootRoute } from '@buses/bus-results/bus-results-routing.module';
import { packagesHomeRootRoute, packagesResultsRootRoute } from '@packages/packages-home/constants/packages.routes';
import { HomeFacade } from '@home/home.facade';
import { countryModulesByWidgetsConfig } from '@home/mappers/home.mapper';
import { ModuleEntity } from '@app/entities/modules-country';
import { FLIGHT, HOTELS, BUSES, PACKAGES, AUTOS, TOUR_AND_ACTIVITIES } from '@app/constants/route-titles.constants';
import { autoHomeRootRoute } from '@autos/auto-home/constants/routes';
import { activitiesHomeRootRoute } from '@activities/constants/activities.routes';

@Injectable()
export class ModuleCountryGuard  {

  constructor(
    private router: Router,
    private homeFacade: HomeFacade) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.homeFacade.homeData$.pipe(
      map(homeData => countryModulesByWidgetsConfig(homeData?.widgets)),
      map((widgets: ModuleEntity[]) => {
        const currentUrl = state.url;
    
        if (this.currentUrlInclude(currentUrl, [flightsRootRoute, flightResultsRootRoute]) && 
        this.isWidgetIncluded(widgets, FLIGHT)) {
          this.router.navigate(['/']);
          return false;
        }
        if (this.currentUrlInclude(currentUrl, [hotelsHomeRootRoute, hotelResultsRootRoute, hotelDetailRootRoute]) &&
        this.isWidgetIncluded(widgets, HOTELS)) {
          this.router.navigate(['/']);
          return false;
        }
        if (this.currentUrlInclude(currentUrl, [busesRootRoute, busResultsRootRoute]) &&
          this.isWidgetIncluded(widgets, BUSES)) {
          this.router.navigate(['/']);
          return false;
        }
        if (this.currentUrlInclude(currentUrl, [packagesHomeRootRoute, packagesResultsRootRoute]) &&
        this.isWidgetIncluded(widgets, PACKAGES)) {
          this.router.navigate(['/']);
          return false;
        }
        if (this.currentUrlInclude(currentUrl, [autoHomeRootRoute]) &&
        this.isWidgetIncluded(widgets, AUTOS)) {
          this.router.navigate(['/']);
          return false;
        }
        if (this.currentUrlInclude(currentUrl, [activitiesHomeRootRoute]) &&
        this.isWidgetIncluded(widgets, TOUR_AND_ACTIVITIES)) {
          this.router.navigate(['/']);
          return false;
        }
        return true;
      })
    )

  }

  private currentUrlInclude(currentUrl: string, urls: string[]): boolean {
    for (const url of urls) {
      if (currentUrl.includes(url)) {
        return true;
      }
    }
  }

  private isWidgetIncluded(widgets: ModuleEntity[], type: string): boolean {
    return !!widgets.find(widget => widget.widget === type);
  }
}
